import type * as Types from '~/api/schema.graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ModifyChangesetDiffOnUpdate_Budget_Fragment = (
  { readonly __typename?: 'Budget' }
  & Pick<Types.Budget, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_BudgetRecord_Fragment = (
  { readonly __typename?: 'BudgetRecord' }
  & Pick<Types.BudgetRecord, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_InternshipEngagement_Fragment = (
  { readonly __typename?: 'InternshipEngagement' }
  & Pick<Types.InternshipEngagement, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_InternshipProject_Fragment = (
  { readonly __typename?: 'InternshipProject' }
  & Pick<Types.InternshipProject, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_LanguageEngagement_Fragment = (
  { readonly __typename?: 'LanguageEngagement' }
  & Pick<Types.LanguageEngagement, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_MomentumTranslationProject_Fragment = (
  { readonly __typename?: 'MomentumTranslationProject' }
  & Pick<Types.MomentumTranslationProject, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_MultiplicationTranslationProject_Fragment = (
  { readonly __typename?: 'MultiplicationTranslationProject' }
  & Pick<Types.MultiplicationTranslationProject, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdate_Partnership_Fragment = (
  { readonly __typename?: 'Partnership' }
  & Pick<Types.Partnership, 'id'>
  & { readonly changeset?: Types.Maybe<(
    { readonly __typename?: 'ProjectChangeRequest' }
    & Pick<Types.ProjectChangeRequest, 'id'>
    & { readonly difference: (
      { readonly __typename?: 'ChangesetDiff' }
      & { readonly added: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly removed: ReadonlyArray<(
        { readonly __typename: 'Budget' }
        & Pick<Types.Budget, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'BudgetRecord' }
        & Pick<Types.BudgetRecord, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Ceremony' }
        & Pick<Types.Ceremony, 'id'>
      ) | (
        { readonly __typename: 'Comment' }
        & Pick<Types.Comment, 'id'>
      ) | (
        { readonly __typename: 'CommentThread' }
        & Pick<Types.CommentThread, 'id'>
      ) | (
        { readonly __typename: 'CommentViaMentionNotification' }
        & Pick<Types.CommentViaMentionNotification, 'id'>
      ) | (
        { readonly __typename: 'DerivativeScriptureProduct' }
        & Pick<Types.DerivativeScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'DirectScriptureProduct' }
        & Pick<Types.DirectScriptureProduct, 'id'>
      ) | (
        { readonly __typename: 'Directory' }
        & Pick<Types.Directory, 'id'>
      ) | (
        { readonly __typename: 'Education' }
        & Pick<Types.Education, 'id'>
      ) | (
        { readonly __typename: 'EthnoArt' }
        & Pick<Types.EthnoArt, 'id'>
      ) | (
        { readonly __typename: 'FieldRegion' }
        & Pick<Types.FieldRegion, 'id'>
      ) | (
        { readonly __typename: 'FieldZone' }
        & Pick<Types.FieldZone, 'id'>
      ) | (
        { readonly __typename: 'File' }
        & Pick<Types.File, 'id'>
      ) | (
        { readonly __typename: 'FileVersion' }
        & Pick<Types.FileVersion, 'id'>
      ) | (
        { readonly __typename: 'Film' }
        & Pick<Types.Film, 'id'>
      ) | (
        { readonly __typename: 'FinancialReport' }
        & Pick<Types.FinancialReport, 'id'>
      ) | (
        { readonly __typename: 'FundingAccount' }
        & Pick<Types.FundingAccount, 'id'>
      ) | (
        { readonly __typename: 'InternshipEngagement' }
        & Pick<Types.InternshipEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'InternshipProject' }
        & Pick<Types.InternshipProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Language' }
        & Pick<Types.Language, 'id'>
      ) | (
        { readonly __typename: 'LanguageEngagement' }
        & Pick<Types.LanguageEngagement, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Location' }
        & Pick<Types.Location, 'id'>
      ) | (
        { readonly __typename: 'MomentumTranslationProject' }
        & Pick<Types.MomentumTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'MultiplicationTranslationProject' }
        & Pick<Types.MultiplicationTranslationProject, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'NarrativeReport' }
        & Pick<Types.NarrativeReport, 'id'>
      ) | (
        { readonly __typename: 'Organization' }
        & Pick<Types.Organization, 'id'>
      ) | (
        { readonly __typename: 'OtherProduct' }
        & Pick<Types.OtherProduct, 'id'>
      ) | (
        { readonly __typename: 'Partner' }
        & Pick<Types.Partner, 'id'>
      ) | (
        { readonly __typename: 'Partnership' }
        & Pick<Types.Partnership, 'id'>
        & { readonly changeset?: Types.Maybe<(
          { readonly __typename?: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        )> }
      ) | (
        { readonly __typename: 'Post' }
        & Pick<Types.Post, 'id'>
      ) | (
        { readonly __typename: 'ProgressReport' }
        & Pick<Types.ProgressReport, 'id'>
      ) | (
        { readonly __typename: 'ProjectChangeRequest' }
        & Pick<Types.ProjectChangeRequest, 'id'>
      ) | (
        { readonly __typename: 'ProjectMember' }
        & Pick<Types.ProjectMember, 'id'>
      ) | (
        { readonly __typename: 'Story' }
        & Pick<Types.Story, 'id'>
      ) | (
        { readonly __typename: 'SystemNotification' }
        & Pick<Types.SystemNotification, 'id'>
      ) | (
        { readonly __typename: 'Tool' }
        & Pick<Types.Tool, 'id'>
      ) | (
        { readonly __typename: 'ToolUsage' }
        & Pick<Types.ToolUsage, 'id'>
      ) | (
        { readonly __typename: 'Unavailability' }
        & Pick<Types.Unavailability, 'id'>
      ) | (
        { readonly __typename: 'User' }
        & Pick<Types.User, 'id'>
      )>, readonly changed: ReadonlyArray<(
        { readonly __typename?: 'ResourceChange' }
        & { readonly previous: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ), readonly updated: (
          { readonly __typename: 'Budget' }
          & Pick<Types.Budget, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'BudgetRecord' }
          & Pick<Types.BudgetRecord, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Ceremony' }
          & Pick<Types.Ceremony, 'id'>
        ) | (
          { readonly __typename: 'Comment' }
          & Pick<Types.Comment, 'id'>
        ) | (
          { readonly __typename: 'CommentThread' }
          & Pick<Types.CommentThread, 'id'>
        ) | (
          { readonly __typename: 'CommentViaMentionNotification' }
          & Pick<Types.CommentViaMentionNotification, 'id'>
        ) | (
          { readonly __typename: 'DerivativeScriptureProduct' }
          & Pick<Types.DerivativeScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'DirectScriptureProduct' }
          & Pick<Types.DirectScriptureProduct, 'id'>
        ) | (
          { readonly __typename: 'Directory' }
          & Pick<Types.Directory, 'id'>
        ) | (
          { readonly __typename: 'Education' }
          & Pick<Types.Education, 'id'>
        ) | (
          { readonly __typename: 'EthnoArt' }
          & Pick<Types.EthnoArt, 'id'>
        ) | (
          { readonly __typename: 'FieldRegion' }
          & Pick<Types.FieldRegion, 'id'>
        ) | (
          { readonly __typename: 'FieldZone' }
          & Pick<Types.FieldZone, 'id'>
        ) | (
          { readonly __typename: 'File' }
          & Pick<Types.File, 'id'>
        ) | (
          { readonly __typename: 'FileVersion' }
          & Pick<Types.FileVersion, 'id'>
        ) | (
          { readonly __typename: 'Film' }
          & Pick<Types.Film, 'id'>
        ) | (
          { readonly __typename: 'FinancialReport' }
          & Pick<Types.FinancialReport, 'id'>
        ) | (
          { readonly __typename: 'FundingAccount' }
          & Pick<Types.FundingAccount, 'id'>
        ) | (
          { readonly __typename: 'InternshipEngagement' }
          & Pick<Types.InternshipEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'InternshipProject' }
          & Pick<Types.InternshipProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Language' }
          & Pick<Types.Language, 'id'>
        ) | (
          { readonly __typename: 'LanguageEngagement' }
          & Pick<Types.LanguageEngagement, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Location' }
          & Pick<Types.Location, 'id'>
        ) | (
          { readonly __typename: 'MomentumTranslationProject' }
          & Pick<Types.MomentumTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'MultiplicationTranslationProject' }
          & Pick<Types.MultiplicationTranslationProject, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'NarrativeReport' }
          & Pick<Types.NarrativeReport, 'id'>
        ) | (
          { readonly __typename: 'Organization' }
          & Pick<Types.Organization, 'id'>
        ) | (
          { readonly __typename: 'OtherProduct' }
          & Pick<Types.OtherProduct, 'id'>
        ) | (
          { readonly __typename: 'Partner' }
          & Pick<Types.Partner, 'id'>
        ) | (
          { readonly __typename: 'Partnership' }
          & Pick<Types.Partnership, 'id'>
          & { readonly changeset?: Types.Maybe<(
            { readonly __typename?: 'ProjectChangeRequest' }
            & Pick<Types.ProjectChangeRequest, 'id'>
          )> }
        ) | (
          { readonly __typename: 'Post' }
          & Pick<Types.Post, 'id'>
        ) | (
          { readonly __typename: 'ProgressReport' }
          & Pick<Types.ProgressReport, 'id'>
        ) | (
          { readonly __typename: 'ProjectChangeRequest' }
          & Pick<Types.ProjectChangeRequest, 'id'>
        ) | (
          { readonly __typename: 'ProjectMember' }
          & Pick<Types.ProjectMember, 'id'>
        ) | (
          { readonly __typename: 'Story' }
          & Pick<Types.Story, 'id'>
        ) | (
          { readonly __typename: 'SystemNotification' }
          & Pick<Types.SystemNotification, 'id'>
        ) | (
          { readonly __typename: 'Tool' }
          & Pick<Types.Tool, 'id'>
        ) | (
          { readonly __typename: 'ToolUsage' }
          & Pick<Types.ToolUsage, 'id'>
        ) | (
          { readonly __typename: 'Unavailability' }
          & Pick<Types.Unavailability, 'id'>
        ) | (
          { readonly __typename: 'User' }
          & Pick<Types.User, 'id'>
        ) }
      )> }
    ) }
  )> }
);

export type ModifyChangesetDiffOnUpdateFragment = ModifyChangesetDiffOnUpdate_Budget_Fragment | ModifyChangesetDiffOnUpdate_BudgetRecord_Fragment | ModifyChangesetDiffOnUpdate_InternshipEngagement_Fragment | ModifyChangesetDiffOnUpdate_InternshipProject_Fragment | ModifyChangesetDiffOnUpdate_LanguageEngagement_Fragment | ModifyChangesetDiffOnUpdate_MomentumTranslationProject_Fragment | ModifyChangesetDiffOnUpdate_MultiplicationTranslationProject_Fragment | ModifyChangesetDiffOnUpdate_Partnership_Fragment;

export const ModifyChangesetDiffOnUpdateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifyChangesetDiffOnUpdate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangesetAware"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changeset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"difference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"added"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangesetId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangesetAware"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changeset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Id"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangesetId"}}]}}]} as unknown as DocumentNode<ModifyChangesetDiffOnUpdateFragment, unknown>;